export default __webpack_public_path__ + "static/media/virus.6dfb70b7.png";